import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getDisplayName from 'react-display-name';

export type WithDirection = {
  isRTL?: boolean;
};

export const withDirection = <P extends WithDirection>(Component: React.ComponentType<P>) => {
  const WithDirectionComponent = (props: P) => (
    <div dir={props.isRTL ? 'rtl' : undefined}>
      <Component {...props} />
    </div>
  );
  WithDirectionComponent.displayName = `withDirection(${getDisplayName(Component)})`;

  hoistNonReactStatics(WithDirectionComponent, Component);

  return WithDirectionComponent;
};
